export default __webpack_public_path__ + "static/media/teaser3small.517773c3.jpg";